

import { CropFree, ExitToApp, ZoomInMap } from "@mui/icons-material";
import { Avatar, Button, Grid, IconButton, TextField, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useStyle } from "../style";
import { useNavigate } from "react-router-dom";
import Logo from "../../../../../assets/images/Girlush Logo.png";
import { Helmet } from "react-helmet-async";
import moment from "moment";
import BillingTable from "./billingTable";
import { useDispatch } from "react-redux";
import axios from "axios";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import DialogCancel from "../../../../../components/utils/dialogCancel/dialogCancel";

const BarcodeDiscount = () => {
  const classes = useStyle();
  const fullscreenRef = useRef(null);
  const outlet_id = localStorage.getItem("outlet_id");
  const codeRef = useRef(null);
  const [selectedMode, setSelectedMode] = useState("cash");
  const [reward, setReward] = useState(0);
  const [op, setOp] = useState(false);
  const [returnAmnt, setReturnAmnt] = useState("");
  const [enableRedeem, setEnableRedeem] = useState(false);
  const [count, setCount] = useState(0);
  const [member, setMember] = useState(false);
  const [subCatName, setSubCatName] = useState("");
  const [isLoader, setIsLoader] = useState(false);
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
    const [dialogClose, setDialogClose] = useState(false);
  
  const dispatch = useDispatch();

  const [billPoints, setBillPoints] = useState({
    total: 0,
    defaultPoint: 0,
  });
  const [poDetails, setPoDetails] = useState({
    docDate: moment().format(),
    salesManId: null,
  });
  const [thisBill, setThisBill] = useState(0);
  const [data, setData] = useState([]);
  const [docName, setDocName] = useState("");
  const [docNameDefault, setDocNameDefault] = useState("");

  const [code, setCode] = useState("");
  const [discount, setDiscount] = useState("");
  const [discountError, setDiscountError] = useState(""); // State for discount validation error
  const navigate = useNavigate();
  const [postData, setPostData] = useState({
    docdate: "",
    amount: "",
    subtotal_amount: "",
    gst_per: 0,
    gst_amt: "",
    cess_per: 0,
    cess_amt: "",
    roff: "",
    is_credit: 0,
    salesman_id: "",
    mode: "",
    company_id: 1,
    mobile: "",
    party_name: "",
    address: "",
    gst_in: "",
    outletid: outlet_id,
    loyalty_earned: 0,
    loyalty_redem: 0,
    balance_points: 0,
    return_amount: "",
    return_billno: "",
    outlet_sales_details: [],
    card_amount: "",
    cash_amount: "",
    upi_amount: "",
    transaction_id: "",
    transaction_provider: 1,
    transaction_type: 1,
    less_amount: 0,
  });
  
  const handleCodeKeyPress = (e) => {
    if (e.key === "Enter" && code !== "") {
      getItemCode(code);
    }
  };

  // const getItemCode = (id) => {
  //   setIsLoader(true);
  //   axios
  //     .get(`/v1/itemdetails/barcode/${id}/${outlet_id}`)
  //     .then((res) => {
  //       console.log(res.data);
  //       setIsLoader(false);
  //       const objData = {
  //         code: code,
  //         barcode_to: id,
  //         qty: 1,
  //         mrp1: res.data.mrp,
  //         pro_name: res.data.pro_name,
  //         rate1: res.data.sale_rate,
  //         gst1: res.data.gst,
  //         disc1: res.data.discount,
  //         gstAmt: parseFloat(res.data.sale_rate * (res.data.gst / 100) * 1).toFixed(2),
  //         cessAmt: parseFloat((res.data.sale_rate - (res.data.sale_rate * res.data.discount) / 100) * (res.data.cess / 100) * 1).toFixed(2),
  //         totalAmt: parseFloat((res.data.sale_rate - (res.data.sale_rate * res.data.discount) / 100) * 1 ).toFixed(2),
  //         ...res.data,
  //       };
  //       const existingItemIndex = data.findIndex(
  //         (item) =>
  //           item.code === objData.code &&
  //           (item.mrp1 === objData.mrp || item.mrp1 === objData.mrp1)
  //       );
  //       const arr = [...data];
  //       setData([]); // Clear the existing data
  //       if (existingItemIndex !== -1) {
  //         dispatch(setSnackbar(true, "error", "Barcode already exists!"));
  //         setData(arr);
  //       } else {
  //         arr.push(objData);
  //         setData(arr);
  //         setCode("");
  //       }
  //       codeRef.current.focus();
  //       // dispatch(setSnackbar(true, "success", "suceee"));
  //       dispatch(setSnackbar(true, "success", "Barcode added successfully!"));

  //     })
  //     .catch((err) => {
  //       setIsLoader(false);
  //       dispatch(setSnackbar(true, "error", err.response?.data?.errors[0]?.message));

  //     });
  // };
  const onClickCancel = () => {
    setDialogClose(false);
  };
  const onClickExit = () => {
    navigate("/");
  };
  // console.log(paymentDetails)
  const handleExit = () => {
    setDialogClose(true);
  };
  // console.log(phonePayHistory)

  const getItemCode = (id) => {
    setIsLoader(true);
    axios
      .get(`/v1/itemdetails/barcode/${id}/${outlet_id}`)
      .then((res) => {
        setIsLoader(false);
        const objData = {
          code: code,
          barcode_to: id,
          qty: 1,
          mrp1: res.data.mrp,
          pro_name: res.data.pro_name,
          rate1: res.data.sale_rate,
          gst1: res.data.gst,
          disc1: res.data.discount,
          gstAmt: parseFloat(res.data.sale_rate * (res.data.gst / 100) * 1).toFixed(2),
          cessAmt: parseFloat((res.data.sale_rate - (res.data.sale_rate * res.data.discount) / 100) * (res.data.cess / 100) * 1).toFixed(2),
          totalAmt: parseFloat((res.data.sale_rate - (res.data.sale_rate * res.data.discount) / 100) * 1).toFixed(2),
          ...res.data,
        };
        const existingItemIndex = data.findIndex(
          (item) =>
            item.code === objData.code &&
            (item.mrp1 === objData.mrp || item.mrp1 === objData.mrp1)
        );
        const arr = [...data];
        setData([]); // Clear the existing data
        if (existingItemIndex !== -1) {
          dispatch(setSnackbar(true, "error", "Barcode already exists!"));
          setData(arr);
        } else {
          arr.unshift(objData);
          // arr.push(objData);
          setData(arr);
          setCode("");
          setShowSuccessSnackbar(true); // Set the flag to show success snackbar
        }
        codeRef.current.focus();
      })
      .catch((err) => {
        setIsLoader(false);
        dispatch(setSnackbar(true, "error", err.response?.data?.errors[0]?.message || "Barcode already exists!"));
      });
  };
  useEffect(() => {
    if (showSuccessSnackbar) {
      dispatch(setSnackbar(true, "success", "Barcode added successfully!"));
      setShowSuccessSnackbar(false); // Reset the flag
    }
  }, [showSuccessSnackbar, dispatch]);
  
  const handleSave = () => {
    setDiscountError(""); // Clear previous error
    // Validate discount
    const discountValue = parseFloat(discount);
    if (isNaN(discountValue) || discountValue < 0 || discountValue > 100) {
      setDiscountError("Plese Enter Discount");
      return; // Stop if validation fails
    }

    if (data.length === 0) {
      dispatch(setSnackbar(true, "error", "No barcode data available!"));
      return;
    }

    const barcodeDetails = data.map(item => ({
      barcode: item.barcode_to,
      prod_id: item.id,
    }));

    const payload = {
      barcode_details: barcodeDetails,
      special_discount: discountValue || 0, // Ensure discount is a number
    };

    setIsLoader(true);

    axios.post('/v1/Item/barcode/dis/update', payload)
      .then(res => {
        setIsLoader(false);
        dispatch(setSnackbar(true, "success", "Data saved successfully!"));
        setData([]);
        setCode("");
        setDiscount("");
      })
      .catch(err => {
        setIsLoader(false);
        const errorMessage = err.response?.data?.errors[0]?.message || "An error occurred while saving data.";
        dispatch(setSnackbar(true, "error", errorMessage));
      });
  };

  const handleCancel = () => {
    setCode("");
    setDiscount("");
    setDiscountError("");
    setData([]);
    setCount(0);
  };

  return (
    <Grid ref={fullscreenRef} className={classes.root}>
      <Helmet>
        <title>Barcode Discount</title>
      </Helmet>

      <Grid className={classes.titleInfo}>
        <Typography variant="h5" fontWeight={600}>
          Barcode Discount
        </Typography>
      </Grid>
      <Grid className={classes.contentGrid}>
        <Grid
          className="w-5/6"
          sx={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            height: "calc(100% - 40px)",
          }}
        >
          <Grid className="p-2" sx={{ flex: 1 }}>
            <Grid container spacing={2} className="p-4">
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <TextField
                  fullWidth
                  label="Enter Barcode"
                  variant="outlined"
                  value={code}
                  onChange={(e) => setCode(e.target.value.toUpperCase())}
                  onKeyPress={handleCodeKeyPress}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="subtitle1" fontWeight={600}>
                  Count: {data.length}
                </Typography>
              </Grid>
            </Grid>
            <BillingTable
              data={data}
              setData={setData}
              code={code}
              setCode={setCode}
              ref={codeRef}
              setPostData={setPostData}
              postData={postData}
              docName={docName}
              poDetails={poDetails}
              setCount={setCount}
              setSubCatName={setSubCatName}
            />
          </Grid>

          <Grid container spacing={2} className="p-4">
          <Grid item xs={12} sm={6} md={4} lg={3}>
                <TextField
                  fullWidth
                  label="Discount Percentage"
                  variant="outlined"
                  value={discount}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Check if value is a valid number
                    if (/^\d*\.?\d*$/.test(value) || value === "") {
                      setDiscount(value);
                      setDiscountError(""); // Clear error on input change
                    }
                  }}
                  // onChange={(e) => {
                  //   setDiscount(e.target.value);
                  //   setDiscountError(""); // Clear error on input change
                  // }}
                  // onChange={(e) => setDiscount(e.target.value)}
                  error={!!discountError} // Show error state
                  helperText={discountError} // Display error message
                />
              </Grid>
            <Grid item>
              <Button variant="contained" color="primary" onClick={handleSave}>
                Save
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" color="secondary" onClick={handleCancel}>
                Cancel
              </Button>
            </Grid>
            <Grid item>
                <Button
                        size="small"
                        variant="contained"
                        sx={{ backgroundColor: "red !important" }}
                        startIcon={<ExitToApp />}
                        onClick={handleExit}
                      >
                        Exit
                      </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <DialogCancel
        onClickCancel={onClickCancel}
        onClickExit={onClickExit}
        dialogClose={dialogClose}
        setDialogClose={setDialogClose}
      />
    </Grid>
  );
};

export default BarcodeDiscount;
